import { type NamespaceKeys, type NestedKeyOf, type NestedValueOf } from "next-intl"
import { type OnboardingRouteNames, OnboardingRouteNames as Routes } from "@/routes/onboarding"

type StickyReinsuranceStepKey = NamespaceKeys<
    NestedValueOf<IntlMessages, "StickyReinsurances">,
    NestedKeyOf<NestedValueOf<IntlMessages, "StickyReinsurances">>
>

type StickyReinsuranceConfig = {
    image: string
    translationKey: StickyReinsuranceStepKey
}

const ILLUSTRATIONS = {
    lyingDownLove: "/assets/images/illustrations/constantine-lying-down-love.svg",
    onComputer: "/assets/images/illustrations/constantine-on-computer.svg",
    protectorThunder: "/assets/images/illustrations/constantine-protector-thunder.svg",
    phoneOps: "/assets/images/illustrations/constantine-phone-ops.svg",
    withHearts: "/assets/images/illustrations/constantine-with-hearts.svg",
} as const

export const DEFAULT_STICKY_REINSURANCE_CONFIG: StickyReinsuranceConfig = {
    image: ILLUSTRATIONS.lyingDownLove,
    translationKey: "meterDetails",
}

export const STICKY_REINSURANCE_CONFIG_BY_STEP: Partial<
    Record<OnboardingRouteNames, StickyReinsuranceConfig>
> = {
    [Routes.MeterDetails]: {
        image: ILLUSTRATIONS.lyingDownLove,
        translationKey: "meterDetails",
    },
    [Routes.MeterDetailsMonoEnergy]: {
        image: ILLUSTRATIONS.lyingDownLove,
        translationKey: "meterDetails",
    },
    [Routes.ProviderCalendar]: {
        image: ILLUSTRATIONS.lyingDownLove,
        translationKey: "providerCalendar",
    },
    [Routes.EnergyLandscape]: {
        image: ILLUSTRATIONS.onComputer,
        translationKey: "energyLandscape",
    },
    [Routes.PersonalDetails]: {
        image: ILLUSTRATIONS.protectorThunder,
        translationKey: "personalDetails",
    },
    [Routes.PaymentDetails]: {
        image: ILLUSTRATIONS.phoneOps,
        translationKey: "paymentDetails",
    },
    [Routes.OrderReview]: {
        image: ILLUSTRATIONS.withHearts,
        translationKey: "orderReview",
    },
}
